module.exports = __webpack_public_path__ + "img/imgstep2.3b661bf2.svg";